// Provenance: where the data came from and how fresh it is.

import { useGuide } from './context';
import { Card, SectionHead, Kv } from './components';

export function AboutSection() {
  const { t, flow, lang, model } = useGuide();
  const fmt = (iso?: string) => {
    if (!iso) return t('unknown');
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return new Intl.DateTimeFormat(lang === 'nl' ? 'nl-NL' : 'en-GB', { dateStyle: 'medium', timeStyle: 'short' }).format(d);
  };
  const rows: Array<[string, string]> = [
    [t('source'), flow.sync?.source === 'auto' ? t('autoSync') : flow.source ? t('manualImport') : t('unknown')],
  ];
  if (flow.source?.exportedAt || flow.sync?.exportedAt) rows.push([t('exportTaken'), fmt(flow.sync?.exportedAt || flow.source?.exportedAt)]);
  if (flow.sync?.lastSyncAt) rows.push([t('syncedFromTeams'), fmt(flow.sync.lastSyncAt)]);
  else if (flow.source?.importedAt) rows.push([t('importedFromTeams'), fmt(flow.source.importedAt)]);
  rows.push([t('lastUpdated'), `${fmt(flow.updatedAt)}${flow.updatedBy ? ` · ${flow.updatedBy}` : ''}`]);
  if (flow.source?.autoAttendantName) rows.push(['Teams', flow.source.autoAttendantName]);
  rows.push([t('statsMenus'), String(model.stats.menus)], [t('statsDepartments'), String(model.stats.departments)], [t('statsAgents'), String(model.stats.agents)]);
  return (
    <div className="space-y-3">
      <SectionHead title={t('aboutTitle')} />
      <Card className="p-4 space-y-3">
        <p className="text-sm text-gray-700">{t('aboutText')}</p>
        <Kv rows={rows} />
      </Card>
    </div>
  );
}
